export default "__VITE_ASSET__4dcd39ef__"